module.exports = {"330503100":"南浔镇","330503101":"双林镇","330503102":"练市镇","330503103":"善琏镇","330503104":"旧馆镇","330503105":"菱湖镇","330503106":"和孚镇","330503107":"千金镇","330503108":"石淙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330503.json
// module id = 987
// module chunks = 0